import React from 'react'
import PropTypes from 'prop-types'
import DocumentCard from './Components/DocumentCard'
import './DocumentCardList.sass'

const DocumentsCardList = ({ files }) => (
  <div className='documentsCardList'>
    {files.map((file, i) => (
      <DocumentCard
        key={'File' + file.url + file.name + i}
        url={file.url}
        type={file.type}
        name={file.name}
        size={file.size}
      />
    ))}
  </div>
)

export default DocumentsCardList

DocumentsCardList.propTypes = {
  files: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      size: PropTypes.number,
    }),
  ).isRequired,
}
